import Authentication from "../api/services/Authentication";

export const ClaimsFilter = ({ resources, chk, claim, enforce, children }) => {
    if (Authentication.isClaimValid("System Admin")) {
        return children;
    }

    if (resources) {
        if (Authentication.hasResource(resources))
            return children;
        else
            return <></>
    }
    if (claim.includes("Facility"))
        return children;
    if (claim.includes("ALL"))
        return children;

    if (Array.isArray(claim)) {

        let claimValid = false;
        claim.forEach(element => {
            if (Authentication.isClaimValid(element.trim())) {
                claimValid = true;
            }
        });

        if (Authentication.getFacilityRoles().includes(claim)) {
            claimValid = true
        }

        if (claimValid)
            return children;
    }
    else if (claim.includes(",")) {
        let claims = claim.split(",")
        let claimValid = false;
        claims.forEach(element => {
            if (Authentication.isClaimValid(element.trim())) {
                claimValid = true;
            }
        });
        if (Authentication.getFacilityRoles().includes(claim)) {
            claimValid = true
        }
        if (claimValid)
            return children;
    } else if (Authentication.getFacilityRoles().includes(claim)
        // Authentication.isClaimValid(claim)
    ) {
        return children;
    }

    if (enforce)
        //return window.location = '/logout';
        return window.location = '/noperm';
    return <></>
    // if(security.verifySession()){
    //     return children;
    // }else{
    //     return <LoginScreen />;
    // }
}